export const FamilyType = {
  Single: 'Single',
  Multi: 'Multi'
};

export const LeadType = {
  SOLAR: 'SOLAR',
  SALES: 'SALES',
  MARKETING: 'MARKETING',
  ONBOARDING: 'ONBOARDING'
};

// export const SolarLeadSource = {
//   WEBSITE: 'Website',
//   DAYLIGHT_APP: 'Daylight App Customer',
//   IN_PERSON_EVENT: 'In-Person Event'
// };

// export const SolarSourceName = {
//   MALL_OF_INDIA: 'Mall of India'
// };

export const SolarLeadSource = {
  WEBSITE: 'WEBSITE',
  DAYLIGHT_APP: 'DAYLIGHT_APP',
  IN_PERSON_EVENT: 'IN_PERSON_EVENT'
};

export const SolarSourceName = {
  MALL_OF_INDIA: 'MALL_OF_INDIA'
};

export const PropertyType = {
  Rent: 'Rent',
  Own: 'Own'
};

export const EvOwner = {
  Yes: 'Yes',
  No: 'No',
  Not_Yet: 'Not_Yet'
};

export const LeadTag = {
  HIGH_INTENT_SOLAR: 'High Intent Solar'
};
